import { SiteVideo } from '@sbercloud/uikit-product-site-video';
import { HTMLComment } from './HTMLComment';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export function HeroSlideVideoBg(_ref) {
  var link = _ref.link,
    previewImage = _ref.previewImage,
    layoutType = _ref.layoutType;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(HTMLComment, {
      text: "noindex"
    }), /*#__PURE__*/_jsx(SiteVideo, {
      layoutType: layoutType,
      video: {
        src: link,
        poster: previewImage,
        muted: true,
        loop: true,
        autoPlay: true
      }
    }), /*#__PURE__*/_jsx(HTMLComment, {
      text: "/noindex"
    })]
  });
}